//@ts-nocheck

import { Icon } from "@/components/Icon";
import CDNImage from "@/components/Image/CDNImage";
import { useIsomorphicLayoutEffect } from "hooks/useIsomorphicLayoutEffect";
import * as React from "react";
import PanViewer from "../lib/PanViewer";

type ReactPanZoomProps = {
  image: string;
  alt?: string;
  ref?: any;
  reset: boolean;
  setReset: (value: boolean) => void;
  className?: string;
};

const ReactPanZoom = ({
  image,
  alt,
  ref,
  reset,
  className,
  setReset,
}: ReactPanZoomProps) => {
  const [dx, setDx] = React.useState(0);
  const [dy, setDy] = React.useState(0);
  const [zoom, setZoom] = React.useState(1);

  const resetAll = () => {
    setDx(0);
    setDy(0);
    setZoom(1);
  };

  useIsomorphicLayoutEffect(() => {
    if (reset) {
      resetAll();
      setReset(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reset]);
  const zoomIn = () => {
    if (zoom <= 2.4) setZoom(zoom + 0.2);
  };

  const zoomOut = () => {
    if (zoom >= 1.2) {
      setZoom(zoom - 0.2);
    }
  };

  const onPan = (dx: number, dy: number) => {
    if (zoom <= 1) {
      setDx(0);
      setDy(0);
    }
    setDx(dx);
    setDy(dy);
  };

  return (
    <>
      {zoom > 1 && (
        <div className="absolute right-4 bottom-[110px] z-[2] select-none  bg-white shadow-md rounded-6">
          <div
            onClick={resetAll}
            className="text-center cursor-pointer h-9 w-9  border-b-[#ccc] border-b-[1px]  rounded-6 "
          >
            <Icon
              type="reset"
              className="w-full h-full p-5 text-blue-light hover:text-blue-medium hover:bg-gray-100 rounded-6"
            />
          </div>
        </div>
      )}

      <div className="absolute right-4 bottom-6 z-[2] select-none  bg-white shadow-md rounded-6">
        <div
          onClick={zoomIn}
          className="text-center cursor-pointer h-9 w-9 border-b-[#ccc]  border-b-[1px] rounded-tr-6 rounded-tl-6"
        >
          <Icon
            type="plus"
            className="w-full h-full p-5 text-blue-light hover:text-blue-medium hover:bg-gray-100 rounded-tr-6 rounded-tl-6"
          />
        </div>
        <div
          onClick={zoomOut}
          className="text-center cursor-pointer h-9 w-9 border-b-[#ccc]  border-b-[1px] rounded-6"
        >
          <Icon
            type="minus"
            className="w-full h-full p-5 text-blue-light hover:text-blue-medium hover:bg-gray-100 rounded-6"
          />
        </div>
      </div>
      <PanViewer
        className={`z-[1] ${className}`}
        zoom={zoom}
        setZoom={setZoom}
        pandx={dx}
        pandy={dy}
        onPan={onPan}
        key={dx}
      >
        <CDNImage
          src={image}
          width="1200"
          quality={100}
          height="700"
          alt="product img"
          className="w-full h-full object-contain"
          sizes={"(max-width: 1023px) 100vw, 100vw"}
        />
      </PanViewer>
    </>
  );
};

export default ReactPanZoom;
